module.exports = __webpack_public_path__ + "img/14.b461b0b9.png";